import React from 'react';
import { ArrowLeft, ArrowRight, Loader2 } from 'lucide-react';
import { Button } from './ui/button';

/**
 * Shared step frame: heading, body, and a sticky action bar.
 *
 * The bar is sticky rather than inline because on a phone the continue button
 * would otherwise sit below the fold on every step with more than three fields.
 *
 * There is no slot for step descriptions or footnotes on purpose — the fields
 * and their labels carry the meaning, and explanatory paragraphs above a form
 * are read by nobody.
 */
const StepLayout = ({
  title,
  children,
  onBack,
  onNext,
  nextLabel = 'Continue',
  nextDisabled = false,
  busy = false
}) => (
  <form
    className="flex flex-col gap-6"
    onSubmit={(event) => {
      event.preventDefault();
      if (!busy && !nextDisabled) onNext?.();
    }}
  >
    <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>

    <div className="flex flex-col gap-5">{children}</div>

    <div className="sticky bottom-0 -mx-4 mt-2 border-t border-black/5 bg-background/95 px-4 py-3 pb-safe backdrop-blur">
      <div className="flex items-center gap-3">
        {onBack && (
          <Button type="button" variant="ghost" size="lg" onClick={onBack} disabled={busy}>
            <ArrowLeft className="h-4 w-4" />
            Back
          </Button>
        )}
        <Button
          type="submit"
          size="lg"
          className="flex-1 bg-[var(--brand-accent)] text-[var(--brand-accent-foreground)] hover:opacity-90"
          disabled={nextDisabled || busy}
        >
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
          {nextLabel}
          {!busy && <ArrowRight className="h-4 w-4" />}
        </Button>
      </div>
    </div>
  </form>
);

export default StepLayout;
